<template>
  <div class="profile-tabs">
    <div class="ui-wrapper">
      <nuxt-link
        v-for="(tab, index) in tabs"
        :key="index"
        :to="tab.to"
        :class="{
          'profile-tabs__link': true,
          'profile-tabs__link_active': modelValue.title === tab.title,
        }"
        @click="emit('update:model-value', tab)"
      >
        {{ tab.title }}
        <template v-if="isDefined(tab.count)">
          ({{ tab.count }})
        </template>
      </nuxt-link>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { isDefined } from '~/utils/extra';

type TTab = {
  title: string
  to: string
  count?: number
}

const props = defineProps<{
  tabs: TTab[]
  modelValue: TTab
}>();

const emit = defineEmits<{
  (e: 'update:model-value', value: TTab): void,
}>();
</script>

<style scoped lang="scss">
.profile-tabs {
  text-align: center;
  border-bottom: 1px solid rgba(51,51,51,.1);
  border-top: 1px solid rgba(51,51,51,.1);
  display: flex;
  align-items: center;
  justify-content: center;

  &__link {
    display: inline-flex;
    font-size: 18px;
    line-height: 21px;
    letter-spacing: 1.2px;
    font-weight: 600;
    text-transform: uppercase;
    transition: .3s;
    position: relative;
    padding: 24px 16px;
    color: rgba(51,51,51,.4);
    position: relative;

    &:after {
      content: '';
      position: absolute;
      bottom: -1px;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 2px;
      background: #333;
      transition: width ease-in .2s;
    }

    &:hover {
      color: #333;
    }

    &_active {
      color: #333;

      &:after {
        width: 100%;
      }
    }
  }
}
</style>
